{
  "ar-EG": {
    "showmore": "اقرأ المزيد"
  },
  "ar-SA": {
    "showmore": "اقرأ المزيد"
  },
  "ca-ES": {
    "showmore": "Aprèn més"
  },
  "cs-CZ": {
    "showmore": "Zjistěte více"
  },
  "da-DK": {
    "showmore": "Lær mere"
  },
  "de-AT": {
    "showmore": "Erfahren Sie mehr"
  },
  "de-CH": {
    "showmore": "Erfahren Sie mehr"
  },
  "de-DE": {
    "showmore": "Erfahren Sie mehr"
  },
  "en-CA": {
    "showmore": "Learn more"
  },
  "en-GB": {
    "showmore": "Learn more"
  },
  "en-HK": {
    "showmore": "Learn more"
  },
  "en-IE": {
    "showmore": "Learn more"
  },
  "en-IN": {
    "showmore": "Learn more"
  },
  "en-US": {
    "showmore": "Learn more"
  },
  "es-ES": {
    "showmore": "Más información"
  },
  "es-MX": {
    "showmore": "Más información"
  },
  "fi-FI": {
    "showmore": "Lue lisää"
  },
  "fr-BE": {
    "showmore": "En savoir +"
  },
  "fr-CA": {
    "showmore": "En savoir +"
  },
  "fr-CH": {
    "showmore": "En savoir +"
  },
  "fr-FR": {
    "showmore": "En savoir +"
  },
  "hi-IN": {
    "showmore": "और अधिक जानें"
  },
  "hu-HU": {
    "showmore": "Tudj meg többet"
  },
  "id-ID": {
    "showmore": "Belajarlah lagi"
  },
  "it-IT": {
    "showmore": "Saperne di più"
  },
  "ja-JP": {
    "showmore": "詳細はこちら"
  },
  "ko-KR": {
    "showmore": "더 알아보기"
  },
  "nb-NO": {
    "showmore": "Lære mer"
  },
  "nl-BE": {
    "showmore": "Meer informatie gebruiksaanwijzing"
  },
  "nl-NL": {
    "showmore": "Meer informatie gebruiksaanwijzing"
  },
  "pl-PL": {
    "showmore": "Ucz się więcej"
  },
  "pt-BR": {
    "showmore": "Saber mais"
  },
  "pt-PT": {
    "showmore": "Saber mais"
  },
  "ru-RU": {
    "showmore": "Узнать больше"
  },
  "sv-SE": {
    "showmore": "Läs mer"
  },
  "th-TH": {
    "showmore": "เรียนรู้เพิ่มเติม"
  },
  "tr-TR": {
    "showmore": "Daha fazla bilgi edin"
  },
  "zh-CN": {
    "showmore": "了解更多"
  },
  "zh-HK": {
    "showmore": "了解更多"
  },
  "zh-TW": {
    "showmore": "了解更多"
  }
}
